import React from "react";
import styled from "styled-components";
import { useTrainingStore } from "../../stores/trainingStore";
import { formatTime } from "../../utils/formatTime";

const DisplayCard = styled.div<{
  $phase: "running" | "walking";
  $isActive: boolean;
}>`
  position: relative;
  width: 280px;
  height: 280px;
  margin: 30px auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: var(--card-bg);
  border: 4px solid
    ${(props) =>
      props.$isActive
        ? props.$phase === "running"
          ? "var(--accent-run)"
          : "var(--accent-walk)"
        : "#333"};
  box-shadow: ${(props) =>
    props.$isActive
      ? `0 0 30px ${props.$phase === "running" ? "rgba(255, 59, 48, 0.3)" : "rgba(48, 209, 88, 0.3)"}`
      : "none"};
  transition: all 0.4s ease;
`;

const PhaseBadge = styled.span<{ $phase: "running" | "walking" }>`
  background: ${(props) =>
    props.$phase === "running" ? "var(--accent-run)" : "var(--accent-walk)"};
  color: #000;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 900;
  margin-bottom: 5px;
`;

const TimeNumber = styled.h1`
  font-size: 5rem;
  font-weight: 800;
  margin: 0;
  font-variant-numeric: tabular-nums;
`;

export const TimerDisplay: React.FC = () => {
  const { currentPhase, phaseElapsedSeconds, settings, isActive } =
    useTrainingStore();
  const phaseDuration =
    currentPhase === "running"
      ? settings.runMinutes * 60 + settings.runSeconds
      : settings.walkMinutes * 60 + settings.walkSeconds;
  const remaining = Math.max(0, phaseDuration - phaseElapsedSeconds);

  return (
    <DisplayCard $phase={currentPhase} $isActive={isActive}>
      <PhaseBadge $phase={currentPhase}>
        {currentPhase.toUpperCase()}
      </PhaseBadge>
      <TimeNumber>{formatTime(remaining)}</TimeNumber>
    </DisplayCard>
  );
};
